import { AppContext } from "@/contexts/appContexts";
import { AiOutlineClose } from "react-icons/ai";
import { useTranslation } from "next-i18next";
import { useContext, useState } from "react";

import Cookies from "js-cookie";
import { SECURE_COOKIE_OPTIONS } from "@/utils/cookies/cookieOptions";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import useKeyboardViewport from "@/hooks/global/useKeyboardViewport";
import useTouchDevice from "@/hooks/global/useTouchDevice";

const SelectCityPopUp = ({
  isModalOpen,
  setRegionId,
  setAvailableDates,
  regionsData,
}) => {
  const [searchText, setSearchText] = useState("");
  const {
    setIsCityHavefastDelivery,
    setTargetProductDate,
    productInfo,
    setOpenSelectCityPopUp,
  } = useContext(AppContext);
  const {
    t,
    i18n: { language: locale },
  } = useTranslation("common");
  const keyboardViewport = useKeyboardViewport(isModalOpen);
  const isTouch = useTouchDevice();
  // the dialog is fixed-positioned, so collapsing the scrollport cannot strand
  // it the way it would a sticky ancestor
  useBodyScrollLock(isModalOpen, { lockViewport: true });

  return (
    <>
      {isModalOpen ? (
        <div
          // once the keyboard is up, only the visual viewport says what is
          // still visible; without one the CSS sizing already does, and
          // overriding it on every URL-bar change re-centres the dialog
          style={
            keyboardViewport
              ? {
                  top: keyboardViewport.offsetTop,
                  height: keyboardViewport.height,
                  bottom: "auto",
                }
              : undefined
          }
          className="fixed inset-0 z-[3000] flex items-center justify-center"
        >
          {/* the backdrop follows browser chrome so no strip of the page shows
              while the URL bar comes back; resizing a flat colour is invisible,
              resizing the box that centres the dialog is not */}
          <div
            aria-hidden="true"
            className="fixed inset-0 h-[100dvh] bg-lightblack"
          />
          <div
            role="dialog"
            aria-modal="true"
            className="relative z-10 flex flex-col p-5 bg-white rounded-md max-h-[90%] w-[450px] max-[450px]:w-full"
          >
            <div className="flex items-center justify-between shrink-0">
              <h1 className="text-lg font-bold">{t("ChooseCity")}</h1>
              <AiOutlineClose
                size={24}
                className="cursor-pointer"
                onClick={() => setOpenSelectCityPopUp(false)}
              />
            </div>
            <div className="my-2 shrink-0">
              <p className="font-bold text-zinc-600">
                {t("ChooseDeliveryCity")}
              </p>
              <p className="text-zinc-500">{t("DeliveryTimeVary")}</p>
            </div>
            <input
              autoFocus={!isTouch}
              className="outline-0 border rounded-md p-1.5 mb-2 w-full shrink-0"
              placeholder={t("ChooseCity")}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <ul className="flex-1 min-h-0 p-1.5 max-h-[300px] overflow-y-auto overscroll-contain red-scrollbar">
              {regionsData
                ? regionsData
                    .slice(1)
                    .map(({ label, value }) => ({ label, value }))
                    .filter((city) =>
                      city.label
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    )
                    .map((city) => (
                      <li
                        onClick={async () => {
                          Cookies.set("region_id", city.value, SECURE_COOKIE_OPTIONS);
                          setRegionId(city.value);
                          await import("@/utils/global")
                            .then(({ fastDeliveryAndAvailableDatesLogic }) => {
                              fastDeliveryAndAvailableDatesLogic({
                                setAvailableDates,
                                setTargetProductDate,
                                setIsCityHavefastDelivery,
                                id: city.value,
                                locale,
                              });
                              if (productInfo?.product?.sku) {
                                productInfo?.addToCartRef?.current?.click();
                                setOpenSelectCityPopUp(false);
                              }
                              if (productInfo?.searchInputRef) {
                                productInfo.searchInputRef.focus();
                                setSearchText("");
                                setOpenSelectCityPopUp(false);
                              }
                            })
                            .catch((err) =>
                              console.log("Error formatDate", err)
                            );
                          // .finally(() => {
                          //   if (productInfo?.product?.sku) {
                          //     console.log("Hereeee !!!!!");
                          //     productInfo?.addToCartRef?.current?.click();
                          //     setOpenSelectCityPopUp(false);
                          //   }
                          //   if (productInfo?.searchRef) {
                          //     productInfo?.searchRef?.current?.focus();
                          //     setTimeout(() => {
                          //       setSearchText("");
                          //       setOpenSelectCityPopUp(false);
                          //     }, 0);
                          //   }
                          // });
                        }}
                        key={city.value}
                        className="pb-2 cursor-pointer text-zinc-600 hover:text-red"
                      >
                        {city.label}
                      </li>
                    ))
                : null}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SelectCityPopUp;
